export enum TilesTypes {
    EMPTY,
    SOLID_1,
    END,
    SOLID_2,
    DEADLY,
    GREEN_ALIEN,
    YELLOW_ALIEN,
    RED_ALIEN
}

export interface Tile {
    solid?: boolean
    deadly?: boolean
    spawns?: string
    exit?: boolean
}

export const TilesDefinitions: Array<Tile> = []

TilesDefinitions[TilesTypes.EMPTY] = { solid: false, deadly: false }
TilesDefinitions[TilesTypes.SOLID_1] = { solid: true,  deadly: false }
TilesDefinitions[TilesTypes.END]   = { solid: false, deadly: false, exit: true }
TilesDefinitions[TilesTypes.SOLID_2] = { solid: true,  deadly: false }
TilesDefinitions[TilesTypes.DEADLY] = { solid: false,  deadly: true }


export interface Alien {
    x: number
    y: number
    id: 'green' | 'yellow' | 'red'
    isDead: boolean
}
